import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from './store'; 
import crypto from 'crypto';

const Intercom: React.FC = () => {
	const { user } = useSelector((state: RootState) => state.auth);
	
	useEffect(() => {
		if(user) {
			/* const current_user_email = user?.email;
			const secretKey = 'tWPVttq9kqAdyHE6yKCiae9zTaB8iGZ2rWEB0vBD'; 
			const userIdentifier = current_user_email; 
			const hash = crypto.createHmac('sha256', secretKey).update(userIdentifier).digest('hex'); */
			window.intercomSettings = {
				api_base: "https://api-iam.intercom.io",
				app_id: "tl53k1w1",
				user_id: user?.id,
				// user_hash: hash,
				name: `${user?.profile.first_name} ${user?.profile.last_name}`,
				email: user?.email,
				created_at: user?.created_at,
			};
		} else {
			  window.intercomSettings = {
				api_base: "https://api-iam.intercom.io",
				app_id: "tl53k1w1",
			  };
		}
		// We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/tl53k1w1';
		(function(){
			const w = window;
			const ic = w.Intercom;
			if(typeof ic === 'function'){
				ic('reattach_activator');
				ic('update', w.intercomSettings);
			}else{
				const d = document;
				const i = function(...args){
					i.c(args);
				};
				i.q = [];
				i.c = function(args){
					i.q.push(args);
				};
				w.Intercom=i;
				const l = function(){
					const s = d.createElement('script');
					s.type = 'text/javascript';
					s.async = true;
					s.src = 'https://widget.intercom.io/widget/tl53k1w1';
					const x = d.getElementsByTagName('script')[0];
					x.parentNode.insertBefore(s,x);
				};
				if(document.readyState === 'complete'){
					l();
				}else if(w.attachEvent){
					w.attachEvent('onload',l);
				}else{
					w.addEventListener('load',l,false);
				}
			}
		})();
	}, [user]);

	return (
		<>	
		</>
	);

}
export default Intercom;